import { Card } from "@closer/ui";
import { useQuery } from "@tanstack/react-query";

import { api } from "../../lib/apiClient";
import { useAuth } from "../../lib/authContext";
import { tenantKey } from "../../lib/tenantQuery";
import { ContractClientAreaBox } from "./ContractClientAreaBox";

/**
 * MÜVEKKİL ALANI — KENDİ BÖLÜMÜ (CLOS-1128 · rapor §2.3 · §3.2 "Müvekkil Alanı paylaşımı →
 * Müvekkil Alanı").
 *
 * Faz 5'in kanonik kutusu (`ContractClientAreaBox`) eskiden mega "Paylaşım ve Ortak Çalışma"
 * panelinin içinde duruyordu; kullanıcı "sözleşmeyi müvekkille paylaş" niyetini panelin
 * dört bloğu arasında arıyordu. T.1 matrisi: bu niyetin yüzeyi Müvekkil Alanı kutusudur,
 * başka hiçbir yerde tekrar etmez. Yönetim kapısı sunucudan (`sharing-context.canManage`);
 * yönetemeyen kullanıcı yalnız sözleşmenin hangi alanlara açık olduğunu okur.
 */
export function ContractClientAreaSection({ contractId }: { contractId: string }) {
  const { activeTenantId, can } = useAuth();
  const tenantId = activeTenantId!;
  const baglamAnahtari = tenantKey(tenantId, "contract", contractId, "paylasim-baglami");
  const baglam = useQuery({
    enabled: can("contract.view"),
    queryKey: baglamAnahtari,
    queryFn: async () =>
      (
        await api<{
          clientAreas: { workspaceTenantId: string; clientName: string }[];
          canManage: boolean;
        }>(`/api/contracts/${contractId}/sharing-context`, { tenantId })
      ).data,
  });
  if (!can("contract.view")) return null;
  const yonetebilir = baglam.data?.canManage ?? false;
  const acikAlanlar = baglam.data?.clientAreas ?? [];
  return (
    <Card>
      {yonetebilir ? (
        <ContractClientAreaBox
          contractId={contractId}
          tenantId={tenantId}
          yonetebilir
          baglamAnahtari={baglamAnahtari}
        />
      ) : (
        <section className="flex flex-col gap-2" data-testid="muvekkil-alani-salt-okunur">
          <h3 className="text-xs font-medium text-fg-strong">Müvekkil Alanı</h3>
          {acikAlanlar.length === 0 ? (
            <p className="text-sm text-fg-muted">Bu sözleşme bir Müvekkil Alanına açılmadı.</p>
          ) : (
            <ul className="flex flex-col">
              {acikAlanlar.map((alan) => (
                <li key={alan.workspaceTenantId} className="py-1 text-sm text-fg">
                  {alan.clientName} — Müvekkil Alanına açık
                </li>
              ))}
            </ul>
          )}
        </section>
      )}
    </Card>
  );
}
